document.addEventListener("DOMContentLoaded", () => {
  // StickySidebar 初期化
  var sidebar = new StickySidebar(".shopify-section-group-index-navigation", {
    containerSelector: ".c-index-container",
    innerWrapperSelector: ".sidebar__inner",
    topSpacing: -160,
    resizeSensor: true, // リサイズセンサーを有効にする
    bottomSpacing: 0,
    minWidth: 1200,
  });

  // アコーディオン開閉イベントにフックして高さを再計算
  document.querySelectorAll(".mobile-nav__link").forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        sidebar.updateSticky();
        console.log("Sidebar height recalculated");
      }, 600);
    });
  });

  window.addEventListener("load", () => {
    sidebar.updateSticky();
  });

  const container = document.querySelector(".c-index-container");

  if (container) {
    const observer = new MutationObserver(() => {
      sidebar.updateSticky();
    });

    observer.observe(container, {
      childList: true, // 子要素の追加・削除
      subtree: true, // 子孫要素も対象
      attributes: true, // style や class 変更も対象
    });
  }

  // ====== ロゴのアクティブ制御（264px以上でactive付与） ======
  document.addEventListener("DOMContentLoaded", () => {
    const logo = document.querySelector(".side-navigation__logo");
    if (!logo) return;

    const SCROLL_THRESHOLD = 264; // 264px以上でactive付与
    const MIN_WIDTH = 1201;
    function toggleLogoActive() {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= SCROLL_THRESHOLD) {
        if (window.innerWidth >= MIN_WIDTH) {
          logo.classList.add("active");
        } else {
          logo.classList.remove("active");
        }
      } else {
        logo.classList.remove("active");
      }
    }

    // 初期状態をチェック
    toggleLogoActive();
    window.addEventListener("resize", toggleLogoActive);
    // スクロール時にチェック
    window.addEventListener("scroll", toggleLogoActive);
  });
});

